window.sanitasApp = window.sanitasApp || {}

/**
 * JSdoc missing
 *
 * @param {object} sanitasApp
 * @param {object} window
 * @param {object} document
 */
;(function (sanitasApp, window, document) {
  'use strict'

  var boxes = document.querySelectorAll('.sanitas-seal--type-card')
  var boxesAreAbsent = boxes.length === 0

  if (boxesAreAbsent) {
    return
  }

  sanitasApp.utils.autoHeight('.sanitas-seal--type-card')
})(window.sanitasApp, window, document)
